import { createFileRoute } from "@tanstack/react-router";

import Developer from "../pages/Developer";
import { RequireAuth } from "../utils/RequireAuth";

function parseDeveloperSearch(search: Record<string, unknown>) {
  return {
    tab:
      search.tab === "webhooks"
        ? ("webhooks" as const)
        : search.tab === "signed-metadata"
          ? ("signed-metadata" as const)
          : ("api-keys" as const),
    environment: typeof search.environment === "string" ? search.environment : undefined,
  };
}

export const Route = createFileRoute("/_shell/developer")({
  validateSearch: parseDeveloperSearch,
  component: DeveloperRoute,
});

function DeveloperRoute() {
  return (
    <RequireAuth require="chatbotAccess">
      <Developer />
    </RequireAuth>
  );
}
